module["exports"] = [
  "stadt",
  "dorf",
  "land",
  "scheid",
  "burg"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de/address/city_suffix.js
// module id = 173
// module chunks = 0